(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "@bingads-webui-universal/primitive-utilities"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore"), require("@bingads-webui-universal/primitive-utilities")) : factory(root["underscore"], root["@bingads-webui-universal/primitive-utilities"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FilterSchema", {
  enumerable: true,
  get: function get() {
    return _index.FilterSchema;
  }
});
Object.defineProperty(exports, "flattenEntitySchema", {
  enumerable: true,
  get: function get() {
    return _schemaUtils.flattenEntitySchema;
  }
});
Object.defineProperty(exports, "buildNameToPropertyMapping", {
  enumerable: true,
  get: function get() {
    return _schemaUtils.buildNameToPropertyMapping;
  }
});

var _index = __webpack_require__(8);

var _schemaUtils = __webpack_require__(9);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterSchema = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const operatorMapping = {
  number: ['eq', 'neq', 'gt', 'gte', 'lt', 'lte'],
  integer: ['eq', 'neq', 'gt', 'gte', 'lt', 'lte'],
  array: ['eq', 'neq', 'gt', 'gte', 'lt', 'lte'],
  string: ['contains', 'doesnotcontain', 'startswith', 'endswith', 'eq', 'neq'],
  enum: ['in'],
  boolean: ['eq'],
  datetime: ['eq', 'neq', 'gt', 'gte', 'lt', 'lte'],
  id: ['in']
};

function getSelfFilterableProps(schema) {
  return _underscore.default.chain(schema.properties).pairs().filter(pair => pair[1] && pair[1].filterable === true).object().value();
}

function getDeepFilterableProps(schema) {
  return _underscore.default.chain(schema.properties).pairs().filter(pair => pair[1].type && pair[1].type.toLowerCase() === 'object' && pair[1].schema && pair[1].filterable).map(pair => {
    const parentKey = pair[0];
    return _underscore.default.chain(pair[1].schema.properties) // pick only filterable properties
    .pick(pair[1].filterable).pairs().map(childPair => {
      // set alias on property object
      const prop = _underscore.default.extend({}, childPair[1], {
        alias: pair[1].alias && pair[1].alias[childPair[0]]
      }); // return key-value pair with key = parent/child


      return [parentKey.concat('.', childPair[0]), prop];
    }).value();
  }).flatten(true).object().value();
}

function buildAliasToProp() {
  return _underscore.default.chain(this.filterProps()).pairs().map(pair => _underscore.default.map(_underscore.default.pairs(pair[1].alias || {}), childPair => [childPair[0].concat('.', childPair[1]), pair[0]])).flatten(true).object().value();
}

function buildPropToAlias() {
  return _underscore.default.chain(this.aliasToProp()).pairs().map(pair => {
    const dot = pair[0].indexOf('.');
    const aliasType = pair[0].substring(0, dot);
    const alias = pair[0].substring(dot + 1);
    return [aliasType.concat('.', pair[1]), alias];
  }).object().value();
}

function convertValue(srcPropType, targetPropType, predValue) {
  const srcType = srcPropType.toLowerCase();
  const targetType = targetPropType.toLowerCase(); // only convert some types

  if (srcType === 'number' && targetType === 'integer') {
    return Math.round(predValue);
  }

  return predValue;
}

const conversionFunctionFactory = ({
  sourcePropertyType,
  targetPropName,
  targetProp
}) => {
  const conversionFunc = mongoPredicate => {
    const exprObj = _underscore.default.values(mongoPredicate)[0];

    const predOperator = _underscore.default.keys(exprObj)[0];

    const predValue = _underscore.default.values(exprObj)[0]; // All we need here is the type for src


    const convertedValue = convertValue(sourcePropertyType, targetProp.type, predValue);
    return {
      [targetPropName]: {
        [predOperator]: convertedValue
      }
    };
  };

  return conversionFunc;
};

const legacyConversionFunctionFactory = ({
  sourcePropertyType,
  targetPropName,
  targetProp
}) => {
  const conversionFunc = legacyPredicate => {
    const predValue = legacyPredicate.Values[0];
    const convertedValue = convertValue(sourcePropertyType, targetProp.type, predValue);
    /* eslint-disable no-param-reassign */

    legacyPredicate.SelectedColumn = targetPropName;
    legacyPredicate.Values = [convertedValue];
    /* eslint-enable no-param-reassign */
  };

  return conversionFunc;
};

function buildPropToConversions(isForLegacyFilter, conversionFuncFactory) {
  return _underscore.default.chain(this.entitySchema.properties).pairs().map(([targetPropName, targetProp]) => {
    // Only one property conversion are supported for now.
    if (targetProp.alias && targetProp.alias.propertyConversion) {
      // `conversionSrc` must have `sourcePropertyName` and `sourcePropertyType`.
      // `sourcePropertyName` is long name with '' in b/w parentName and property name.
      // `sourcePropertyLegacyAlias` is the optional legacy alias of the source property.
      const _targetProp$alias$pro = targetProp.alias.propertyConversion,
            sourcePropertyType = _targetProp$alias$pro.sourcePropertyType,
            sourcePropertyName = _targetProp$alias$pro.sourcePropertyName,
            sourcePropertyLegacyAlias = _targetProp$alias$pro.sourcePropertyLegacyAlias;

      if (!sourcePropertyName) {
        throw new Error('Must provide a sourcePropertyName');
      }

      if (!sourcePropertyType) {
        throw new Error('Must provide a sourcePropertyType');
      }

      const conversionFunc = conversionFuncFactory({
        sourcePropertyType,
        targetPropName,
        targetProp
      });
      const finalSourcePropertyName = isForLegacyFilter && sourcePropertyLegacyAlias || sourcePropertyName;
      return [finalSourcePropertyName, conversionFunc];
    }

    return null;
  }).compact().object().value();
}
/**
 * FilterSchema is built upon entity schema.
 * It's used to get filterable properties, get alias using alias type & property key and vice versa.
 */


class FilterSchema {
  /**
   * Constructs a new instance of FilterSchema over the passed in entitySchema.
   * @param {object} entitySchema - the original entity schema object
   */
  constructor(entitySchema) {
    this.entitySchema = entitySchema;
    this.entityName = this.entitySchema.name;

    this.filterProps = () => _underscore.default.extend(getSelfFilterableProps(this.entitySchema), getDeepFilterableProps(this.entitySchema));

    this.aliasToProp = _underscore.default.once(buildAliasToProp.bind(this));
    this.propToAlias = _underscore.default.once(buildPropToAlias.bind(this));
    this.propToConversions = _underscore.default.once(buildPropToConversions.bind(this, false, conversionFunctionFactory));
    this.propToLegacyConversions = _underscore.default.once(buildPropToConversions.bind(this, true, legacyConversionFunctionFactory));
  }
  /**
   * Get entity schema's name.
   * @return {string} - the entity schema's name.
   */


  getEntityName() {
    return this.entityName;
  }
  /**
   * Get keys of filterable properties.
   * @return {array} - array of filterable properties' keys.
   */


  getPropertyKeys() {
    return _underscore.default.keys(this.filterProps());
  }
  /**
   * Get filterable property using property key with formatted attributes.
   * @param {string} propertyKey - the property's key
   * @return {object} - filterable property of given key, null if doesn't exist.
   */


  getFilterProperty(propertyKey) {
    const property = this.filterProps()[propertyKey];

    if (!property) {
      return null;
    }

    const type = property.type.toLowerCase();
    let operators;

    if (!_underscore.default.isEmpty(property.operators)) {
      operators = property.operators; // eslint-disable-line prefer-destructuring
    } else if (_underscore.default.isEmpty(property.enum)) {
      operators = operatorMapping[type];
    } else {
      operators = operatorMapping.enum;
    }

    const result = {
      type,
      operators,
      alias: property.alias,
      name: property.name,
      description: property.description,
      isPercentValue: property.isPercentValue,
      skipLocalization: property.skipLocalization,
      isDeletedProperty: property.isDeletedProperty,
      isInvalidProperty: property.isInvalidProperty,
      title: property.title,
      localized: property.localized,
      nullable: property.nullable,
      maxLength: property.maxLength,
      minimum: property.minimum,
      maximum: property.maximum,
      pattern: property.pattern,
      customEditor: property.customEditor,
      localize: property.localize,
      enumType: property.enumType
    };

    if (property.enum) {
      result.enum = property.enum;
    }

    if (property.chooseType) {
      result.chooseType = property.chooseType;
    }

    if (property.customParameters) {
      result.customParameters = property.customParameters;
    }

    if (property.groupedItems) {
      result.groupedItems = property.groupedItems;
    }

    if (property.hasTime) {
      result.hasTime = property.hasTime;
    }

    if (property.operatorDisplayNameMap) {
      // for customize filter operator text display
      result.operatorDisplayNameMap = property.operatorDisplayNameMap;
    }

    if (property.addtionalParams && _underscore.default.isObject(property.addtionalParams)) {
      // to avoid future trouble, for non-shared params, put it here
      _underscore.default.extendOwn(result, property.addtionalParams);
    }

    return result;
  }
  /**
   * Get alias using property key and alias type.
   * @param {string} propertyKey - property key.
   * @param {string} aliasType - alias type.
   * @return {string} - alias name of given key and alias type
   *                    return propertyKey if alias doesn't exist.
   */


  toAlias(propertyKey, aliasType) {
    let alias = null;

    if (propertyKey && aliasType) {
      alias = this.propToAlias()[aliasType.concat('.', propertyKey)];
    }

    return alias || propertyKey;
  }
  /**
   * Get original property key using alias and alias type.
   * @param {string} alias - alias string.
   * @param {string} aliasType - type of alias.
   * @return {string} - the property key of given alias and alias type
   *                    return alias if propertyKey doesn't exist.
   */


  fromAlias(alias, aliasType) {
    let propertyKey = null;

    if (alias && aliasType) {
      propertyKey = this.aliasToProp()[aliasType.concat('.', alias)];
    }

    return propertyKey || alias;
  }

  getApplicableConversions(propName) {
    const allConversions = this.propToConversions();
    return _underscore.default.isUndefined(allConversions[propName]) ? _underscore.default.identity : allConversions[propName];
  }

  getApplicableLegacyConversions(propName) {
    const allConversions = this.propToLegacyConversions();
    return _underscore.default.isUndefined(allConversions[propName]) ? _underscore.default.identity : allConversions[propName];
  }

  applyConversions(mongoPredicate) {
    const propName = _underscore.default.keys(mongoPredicate)[0];

    return this.getApplicableConversions(propName)(mongoPredicate);
  }

  applyLegacyFilterConversions(legacyFilterExpressions) {
    _underscore.default.each(legacyFilterExpressions, legacyExpression => {
      const propName = legacyExpression.SelectedColumn;
      this.getApplicableLegacyConversions(propName)(legacyExpression);
    });
  }

}

exports.FilterSchema = FilterSchema;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapEnumValueForFilter = mapEnumValueForFilter;
exports.buildNameToPropertyMapping = buildNameToPropertyMapping;
exports.flattenEntitySchema = flattenEntitySchema;

var _underscore = _interopRequireDefault(__webpack_require__(3));

var _primitiveUtilities = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const primitiveTypes = ['string', 'number', 'integer', 'boolean', 'datetime']; // const assumes that there is only one conversion

const conversionAlias = 'propertyConversion'; // Map enum value like 'Eligible' For DeliveryStatus to "Enum.DeliveryStatus'Eligible'"

function mapEnumValueForFilter(enumType, enumValue) {
  return `Enum.${enumType}'${enumValue}'`;
}

function buildNameToPropertyMapping(entitySchema, mapOnlyBaseProperty) {
  // TODO 893787 Provide generic support for customizable entity schema to filter property mapping
  if (mapOnlyBaseProperty) {
    return _underscore.default.mapObject(entitySchema.properties, propObj => _underscore.default.last(propObj.property.split('/')));
  }

  return _underscore.default.mapObject(entitySchema.properties, propObj => propObj.property);
}

function restoreToEntitySchema(flattenedEntity) {
  const properties = _underscore.default.reduce(flattenedEntity.fields, (memo, field) => {
    // eslint-disable-next-line no-param-reassign
    memo[field.name] = _underscore.default.defaults({
      filterable: true
    }, field);
    return memo;
  }, {});

  return _underscore.default.defaults({
    properties
  }, _underscore.default.pick(flattenedEntity, 'name', 'type', 'operators'));
} // Any function that deals with property conversion uses
// the assumption there is only one propertyAlternation
// In another word only one convesion is allowed


const hasConversionAlias = alias => _underscore.default.has(alias, conversionAlias);

function flattenSchemaToFields(entitySchema) {
  const fields = [];
  const nameStack = [];

  function buildFilters(schema) {
    _underscore.default.each(schema.properties, (prop, name) => {
      const parentNameStack = [...nameStack];
      nameStack.push(name);
      const property = nameStack.join('/');
      const propertyName = nameStack.join('');

      if (prop.type === 'object' && prop.schema && prop.filterable !== false) {
        // do not use original schema to not break it
        const schemaToBuild = (0, _primitiveUtilities.cloneDeep)(prop.schema); // did not build options for ones not filterable within an object

        if (_underscore.default.isArray(prop.filterable)) {
          schemaToBuild.properties = _underscore.default.pick(schemaToBuild.properties, prop.filterable); // add filterable to those properties in case they don't have them

          _underscore.default.each(schemaToBuild.properties, (subPro, key) => {
            subPro.filterable = true; // eslint-disable-line no-param-reassign

            if (_underscore.default.has(prop.alias, key)) {
              subPro.alias = prop.alias[key]; // eslint-disable-line no-param-reassign
            }
          });
        }

        buildFilters(schemaToBuild);
      } else if (_underscore.default.contains(primitiveTypes, prop.type) && prop.filterable) {
        const baseSchema = {
          name: propertyName,
          type: prop.type,
          property,
          isPercentValue: prop.isPercentValue,
          skipLocalization: prop.skipLocalization,
          operators: prop.operators,
          nullable: prop.nullable,
          maxLength: prop.maxLength,
          originalProperty: _underscore.default.last(nameStack),
          minimum: prop.minimum,
          maximum: prop.maximum,
          required: true,
          pattern: prop.pattern,
          localized: prop.localized,
          isDeletedProperty: prop.isDeletedProperty,
          isInvalidProperty: prop.isInvalidProperty
        };

        if (prop.customColumn) {
          baseSchema.name = name;
          baseSchema.title = prop.title;
          baseSchema.isPercentValue = prop.format === 'Percentage';
          baseSchema.id = prop.id;
          baseSchema.format = prop.format;
          baseSchema.customColumn = true;
        }

        if (prop.type === 'datetime') {
          baseSchema.hasTime = prop.hasTime;
        } // Include the custom operators' localization map


        if (prop.operatorDisplayNameMap) {
          baseSchema.operatorDisplayNameMap = prop.operatorDisplayNameMap;
        } // Keep the legacy column name conversion support.


        if (prop.alias) {
          const aliasCopy = (0, _primitiveUtilities.cloneDeep)(prop.alias);

          _underscore.default.extend(baseSchema, {
            alias: aliasCopy
          });

          if (hasConversionAlias(aliasCopy)) {
            // input schema must provide sourcePropertyType and one
            // of parameters, sourceProperty, an odata short name, or
            // sourcePropertyName, a full name with its parentName
            const _aliasCopy$propertyCo = aliasCopy.propertyConversion,
                  sourceProperty = _aliasCopy$propertyCo.sourceProperty,
                  sourcePropertyType = _aliasCopy$propertyCo.sourcePropertyType,
                  sourcePropertyName = _aliasCopy$propertyCo.sourcePropertyName;

            if (!sourcePropertyType) {
              throw new Error('Must provide a sourcePropertyType');
            }

            if (!sourcePropertyName) {
              if (!sourceProperty) {
                throw new Error('Must provide a sourcePropertyName or a sourceProperty');
              }

              const aliasNameStack = [...parentNameStack, sourceProperty];
              const joinedSourceName = aliasNameStack.join('');
              baseSchema.alias.propertyConversion.sourcePropertyName = joinedSourceName;
            }
          }
        } // update settings for enum type


        if (!_underscore.default.isEmpty(prop.enum)) {
          baseSchema.enumValueMap = {};

          _underscore.default.extendOwn(baseSchema, {
            enum: []
          }, _underscore.default.pick(prop, 'chooseType', 'enumType'));

          const enumType = baseSchema.enumType ? baseSchema.enumType : baseSchema.name; // update enum value (for odata converting) & localization

          _underscore.default.each(prop.enum, enumValue => {
            const mappedEnumValue = mapEnumValueForFilter(enumType, enumValue);
            baseSchema.enum.push(mappedEnumValue);
            baseSchema.enumValueMap[mappedEnumValue] = enumValue;
          });
        } else if (prop.type === 'boolean') {
          _underscore.default.extendOwn(baseSchema, _underscore.default.pick(prop, 'chooseType'));
        } else if (prop.type === 'string') {
          _underscore.default.extendOwn(baseSchema, _underscore.default.pick(prop, 'chooseType'));

          if (prop.customParameters) {
            _underscore.default.extendOwn(baseSchema, _underscore.default.pick(prop, 'customParameters'));
          }
        }

        fields.push(baseSchema);
      }

      nameStack.pop(name);
    });
  }

  buildFilters(entitySchema);
  return _underscore.default.defaults({
    fields
  }, _underscore.default.pick(entitySchema, ['name', 'type']));
}

function flattenEntitySchema(entitySchema) {
  return restoreToEntitySchema(flattenSchemaToFields(entitySchema));
}

/***/ })
/******/ ]);
});
